import { useKiosk } from "./useKiosk";

/**
 * 後端 POST /app-api/platform-orders 擋「下單的人手機未驗證」（lpg-app-api，2026-10-15）的錯誤碼。
 * 後端回 403，body { code: 'PHONE_NOT_VERIFIED', message: 'PHONE_NOT_VERIFIED: 請先完成手機驗證' }。
 */
export const PHONE_NOT_VERIFIED_CODE = "PHONE_NOT_VERIFIED";
export const PHONE_NOT_VERIFIED_TOAST = "請先完成手機驗證";

export const isPhoneNotVerifiedError = (error: unknown): boolean => {
  const res = (error as { response?: { status?: number; data?: { code?: unknown; message?: unknown } } } | null | undefined)?.response;
  if (res?.status !== 403) return false;
  if (res.data?.code === PHONE_NOT_VERIFIED_CODE) return true;
  const m = res.data?.message;
  const text = Array.isArray(m) ? m.join(" ") : typeof m === "string" ? m : "";
  return text.includes(PHONE_NOT_VERIFIED_CODE);
};

/**
 * 後端說這個帳號手機還沒驗證 → 讓結算頁（Kiosk 與瓦斯訂購）把簡訊驗證卡叫出來。
 * 會走到這裡的情況：
 *  - 閘門查 /customer/contexts 失敗時放行（fail-open），needCheckoutOtp 停在 false。
 *  - 極少數：本次驗證成功但後端沒記到（markPhoneVerifiedInDb 寫入失敗只記 log）。
 * 清掉 otpVerified 讓卡片回到確認段重新驗證（OtpCard 會跟著重置，見該檔「外部清掉 otpVerified」）。
 */
export const reopenCheckoutOtp = (): void => {
  const k = useKiosk.getState();
  k.setNeedCheckoutOtp(true);
  k.setOtpVerified(false);
  k.setPhoneVerifiedTicket("");
};
